const MONTH_MAP = [
  { header: "JAN", key: "jan" },
  { header: "FEB", key: "feb" },
  { header: "MAR", key: "mar" },
  { header: "APR", key: "apr" },
  { header: "MEI", key: "may" },
  { header: "JUN", key: "jun" },
  { header: "JUL", key: "jul" },
  { header: "AGU", key: "aug" },
  { header: "SEP", key: "sep" },
  { header: "OKT", key: "oct" },
  { header: "NOP", key: "nov" },
  { header: "DES", key: "dec" },
];

export const getTableConfig = (year) => {
  return [
    {
      name: "",
      label: "KATEGORI",
      options: {
        sort: false,
        setCellHeaderProps: () => ({
          // style: {
          //   visibility: "hidden",
          //   height: 0,
          //   padding: 0,
          // },
        }),
      },
    },
    ...MONTH_MAP.map((m) => ({
      name: "",
      label: m.header,
      options: {
        sort: false,
      },
    })),
    {
      name: "",
      label: `YTD ${year ?? ""}`,
      options: {
        sort: false,
      },
    },
  ];
};

export const mapPartInOutYTDToTable = (data = []) => {
  return data.map((item) => [
    item.category,
    ...MONTH_MAP.map((m) => Number(item[m.key] || 0)),
    Number(item.totalYear || 0),
  ]);
};

const MONTH_HEADERS = [
  { key: "jan", label: "JAN" },
  { key: "feb", label: "FEB" },
  { key: "mar", label: "MAR" },
  { key: "apr", label: "APR" },
  { key: "may", label: "MEI" },
  { key: "jun", label: "JUN" },
  { key: "jul", label: "JUL" },
  { key: "aug", label: "AGU" },
  { key: "sep", label: "SEP" },
  { key: "oct", label: "OKT" },
  { key: "nov", label: "NOV" },
  { key: "dec", label: "DES" },
];

export const buildExcelRequestBodyPartInOutYTD = ({ year, dataTable = [] }) => {
  const yearValue = year?.value || year;
  const filename = `${yearValue}_Laporan_Part_In_Out_YTD`;

  const sheets = [];

  if (Array.isArray(dataTable) && dataTable.length > 0) {
    sheets.push({
      name: `Laporan Part In Out YTD ${yearValue}`,
      headers: [
        "No",
        "Kategori",
        ...MONTH_HEADERS.map((m) => m.label),
        `YTD ${yearValue}`,
      ],
      data: dataTable.map((rowData, rowIndex) => {
        const row = {
          No: rowIndex + 1,
          Kategori: rowData[0], 
        };

        MONTH_HEADERS.forEach((month, i) => {
          row[month.label] = rowData[i + 1] ?? 0;
        });

        row[`YTD ${yearValue}`] = rowData[rowData.length - 1] ?? 0;

        return row;
      }),
    });
  }

  return {
    filename,
    sheets,
  };
};
